export default __webpack_public_path__ + "180ba33d8de7dcfe80a0077be8708630.woff";